import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=4f5c1489&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=ts&"
export * from "./logout.vue?vue&type=script&lang=ts&"
import style0 from "./logout.vue?vue&type=style&index=0&id=4f5c1489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5c1489",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
